import { getEnviroment } from '../../../../env';
import axios from 'axios';
import { defaultAxiosOptions } from '../common/DefaultAxiosOptions';
import { AccessToken } from '@okta/okta-auth-js';

const assetEndpoint = getEnviroment().endpoints.asset;
const assetV2Endpoint = getEnviroment().endpoints.assetV2;

interface AssetNote {
  value: string;
}

interface AssetResponse {
  assetId: string;
  name?: string;
  externalReference?: string;
}

export interface AssetInfo {
  name: string;
  referenceNumber: string;
}

const getNote = (accessToken: AccessToken | undefined,
                 assetId: string) => {
  return axios
    .post<AssetNote[]>(
      `${assetEndpoint}/notes/query`,
      { assetIds: [assetId] },
      defaultAxiosOptions(accessToken)
    )
    .then(response => response.data)
    .then(assetNotes => assetNotes.length > 0 ? assetNotes[0].value : "")
    .catch(() => {
      throw new Error(`An Unexpected error occurred while trying to fetch note for asset: ${assetId}`)
    });
}

const updateNote = (accessToken: AccessToken | undefined,
                    assetId: string,
                    note: string) => {
  return axios
    .patch<AssetNote[]>(`${assetEndpoint}/note`,
      {
        identifier: {
          type: 'ASSET_ID',
          value: assetId
        },
        note: note
      },
      defaultAxiosOptions(accessToken)
    )
    .catch(() => {
      throw new Error(`An Unexpected error occurred while trying to update note for asset: ${assetId}`)
    });
};

const getAsset = (accessToken: AccessToken | undefined,
                  assetId: string): Promise<AssetInfo> => {
  return axios
    .get<AssetResponse>(
      `${assetV2Endpoint}/${assetId}`,
      defaultAxiosOptions(accessToken)
    )
    .then(response => response.data)
    .then(asset => ({
      name: asset.name || '',
      referenceNumber: asset.externalReference || ''
    }))
    .catch(() => {
      throw new Error(`An Unexpected error occurred while trying to fetch asset: ${assetId}`);
    });
};

const updateAsset = (accessToken: AccessToken | undefined,
                     assetId: string,
                     name: string,
                     referenceNumber: string): Promise<void> => {
  return axios
    .patch(
      assetV2Endpoint,
      {
        assets: [
          {
            identifier: {
              type: 'ASSET_ID',
              value: assetId
            },
            patchAssetRequest: {
              name: name,
              externalReference: referenceNumber
            }
          }
        ]
      },
      defaultAxiosOptions(accessToken)
    )
    .then(() => undefined)
    .catch(() => {
      throw new Error(`An Unexpected error occurred while trying to update asset: ${assetId}`);
    });
};

export const AssetApi = {
  getNote,
  updateNote,
  getAsset,
  updateAsset
}